import { ajax } from '@/api/ajax'

//课中活动
//1、获取教学课程名称（无分页）
export const reqjxCourseList = () => ajax(`/jxcourse/jxCourse/NoPageList`)



